<template lang="">
  <div class="loaders">
    <div class="loader-container">
        <p class="text-center">{{msg}}</p>
        <button class="backbutton" @click="cancelKyc()" v-if="isButton">Cancel</button>
    <div class="text-center">
      <img :src="require(`@/assets/images/${imageUrl}`)" alt="" />
    </div>
    </div>
  </div>
</template>
<script>
import {getDistributer} from '@/mixins/common';
export default {
  name: "loading-page",
  props: {
    msg: String,
    isButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imageUrl: "pageloader.gif",
    }
  },
  mounted() {
    if (getDistributer()["distributerID"]) {
      const distributorId = getDistributer()["distributerID"];
      if (distributorId === "RIBPL") {
        this.imageUrl = "wealth-right.gif";
      } else {
        this.imageUrl = `pageloader.gif`;
      }
    }
  },
  methods: {
    cancelKyc() {
      window.location.reload(true);
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/components/Loaders.scss";
</style>
